/**
 * Maps each SVG district to its tourism region (§6.1) — the link between the map asset
 * (Other Assets/SJmap.svg, copied and id-normalised into assets/sj-map.svg) and the
 * Region records the API serves.
 *
 * The three "regions" are a marketing grouping, not municipalities: Central Meskheti and
 * Javakheti each span several districts, Borjomi–Bakuriani is one. Each district path in
 * the SVG has a `_black` (default) and `_blue` (#2986FE highlight) variant sharing this
 * stem.
 *
 * ⚠️ The original asset had two inconsistent blue ids (akhalkhalaki_blue,
 * borjom-bakuriani_blue); the copied SVG normalises them so every stem below pairs
 * cleanly with `${stem}_black` / `${stem}_blue`. If the designer re-exports, re-apply the
 * normalisation (see the copy step) or update these stems.
 */

export const DISTRICT_TO_REGION: Record<string, string> = {
  akhaltsikhe: 'central-meskheti',
  adigeni: 'central-meskheti',
  aspindza: 'central-meskheti',
  borjom_bakuriani: 'borjomi-bakuriani',
  akhalkalaki: 'javakheti',
  ninotsminda: 'javakheti',
};

/** District stems belonging to a region — used to highlight a whole region at once. */
export function districtsForRegion(regionSlug: string): string[] {
  return Object.entries(DISTRICT_TO_REGION)
    .filter(([, region]) => region === regionSlug)
    .map(([district]) => district);
}

export const DISTRICT_STEMS = Object.keys(DISTRICT_TO_REGION);

/**
 * The HERO outline map (Other Assets/hero-map.svg) is a DIFFERENT asset from the
 * choropleth: single paths (no _black/_blue), and it names the Borjomi district
 * `borjomi-bakuriani` (hyphen) rather than `borjom_bakuriani`. Its own mapping keeps the
 * two assets decoupled — each is the source of truth for its own path ids.
 */
export const HERO_DISTRICT_TO_REGION: Record<string, string> = {
  akhaltsikhe: 'central-meskheti',
  adigeni: 'central-meskheti',
  aspindza: 'central-meskheti',
  'borjomi-bakuriani': 'borjomi-bakuriani',
  akhalkalaki: 'javakheti',
  ninotsminda: 'javakheti',
};

export const HERO_DISTRICT_IDS = Object.keys(HERO_DISTRICT_TO_REGION);
